import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Primary: solid charcoal that sweeps to sand on hover. Sharp corners.
export const CTAButton = ({ to, href, children, testid, variant = "primary", className = "", icon = true }) => {
  const base =
    "btn-sweep inline-flex items-center gap-3 px-8 py-4 text-xs uppercase tracking-[0.2em] font-medium transition-colors duration-300";
  const styles = {
    primary: "bg-charcoal text-white hover:text-charcoal",
    accent: "bg-sand text-charcoal hover:text-charcoal",
    outline: "border border-charcoal text-charcoal hover:text-charcoal",
    light: "border border-white/40 text-white hover:text-charcoal",
  };
  const content = (
    <>
      <span>{children}</span>
      {icon && <ArrowRight className="h-4 w-4" strokeWidth={1.5} />}
    </>
  );
  const cls = `${base} ${styles[variant]} ${className}`;
  if (href) {
    return (
      <a href={href} data-testid={testid} className={cls}>
        {content}
      </a>
    );
  }
  return (
    <Link to={to} data-testid={testid} className={cls}>
      {content}
    </Link>
  );
};
